var portfolioBreakdown = {
	table: {
		caption: "Portfolio Breakdown",
		name: {
			assetClass: "Asset class",
			currency: "Currency",
			sector: "Sector"
		}
	},
	chart: {
		counting: {
			assetClass: "Asset classes",
			currency: "Valute",
			sector: "Settori"
		},
		topPositions: {
			assetClass: "Top asset classes",
			currency: "Top currencies",
			sector: "Top sectors"
		}
	},
	assetClasses: {
		bond: "Obbligazione",
		commodity: "Materie prime",
		currency: "Valuta",
		debt: "Debito",
		etf: "ETF",
		fund: "Fondo",
		generic: "Generico",
		index: "Indice",
		stock: "Azione",
		interestRate: "Tasso di Interesse",
		structuredProduct: "Prodotto strutturato",
		investmentProduct: "Prodotto di investimento",
		leveragedProduct: "Prodotto a leva",
		option: "Opzione",
		future: "Future"
	}
};
var it = {
	portfolioBreakdown: portfolioBreakdown
};

export { it as default, portfolioBreakdown };
